import type Account from "byzantine/src/Account";

export type AccountGroup = {
  name: string;
  accounts: Account[];
};

/** Groups accounts by Account.getProductGroup() (e.g. "Checking", "Savings"). */
export const groupAccountsByType = (accounts: Account[]): AccountGroup[] => {
  const groups = new Map<string, Account[]>();
  accounts.forEach((account) => {
    const groupName = account.getProductGroup();
    const existing = groups.get(groupName);
    if (existing) {
      existing.push(account);
    } else {
      groups.set(groupName, [account]);
    }
  });
  return Array.from(groups.entries()).map(([name, groupAccounts]) => ({
    name,
    accounts: groupAccounts
  }));
};
